var APP_URL = "https://design.rsmemorialproducts.com/designer/";
var impCartFlow;
var customVarId;
var cartItems;
//Start Name and number 
//End Name and number 

//Get encrypted key
var secretKeyData = "";
$.get(APP_URL + 'api/v1/secretkey', function (html) {
  secretKeyData = JSON.parse(html);
});

/** 
* Get encrypted order data string.
*
* @param {string} urlToEncode - order data string
* @param {string} secretKey - secret key
*/
function encrypt(urlToEncode, secretKey) {
  let enCodedBit, encryptedTxt = '', cipherKey = '5';
  urlToEncode += secretKey;
  for (let i = 0; i < urlToEncode.length; i++) {
    enCodedBit = String.fromCharCode(urlToEncode[i].charCodeAt(0) + cipherKey.charCodeAt(0));
    encryptedTxt += enCodedBit;
  }
  encryptedTxt = (btoa(encryptedTxt))
  return encryptedTxt;
}

$(document).ready(function () {

  // remove if any custom price products are there in cart
  if (window.location.pathname === '/cart') { 
    // Reload the page if it was restored from bfcache
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });
    if (impCartFlow === 'true') {
      // Replace checkout button
      document.querySelector('.cart__checkout-button').style.display = 'none';
      document.getElementsByClassName("cart__ctas")[0].innerHTML +=
        '<button id="Imp-checkout" class="cart__checkout-button button" type="button" onclick="updateCartWidImpProds(cartItems)" disabled>Checkout</button>';
    }
    // Fetch and process the cart data
    fetchAndProcessCartData();

    $.getJSON('/cart.js', function (cartData) {
      if (cartData) {
        let updates = {};
        // Disable the checkout button initially
        document.getElementById('Imp-checkout').disabled = true;
        $.each(cartData.items, function (key, item) {
          if (item.title === "Custom Price") {
            updates[item.variant_id] = 0;
          }
        });

        if (Object.values(updates).length > 0) {
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          })
            .then(response => {
              setTimeout(function () {
                location.reload();
              }, 1000);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        } else {
          document.getElementById('Imp-checkout').disabled = false;
        }
      }
    });
  }

  //end of remove custom price products from cart
  var editCart = 0;
  //   getting cart settings from Imprint admin here
  $.get(APP_URL + "api/v1/settings/carts", function (result) {
    if (result) {
      var response = JSON.parse(result);
      if (response.is_enabled) {
        editCart = 1;
        $(".design-edit-link").css("display", "block");
      }
    }
  });


  // Name number data
  // Get the modal

  $(".nnlink").each(function () {
    var nnobj = $(this);
    var ref_id = nnobj.attr('data-refid');
    $.get(APP_URL + "api/v1/carts/isNameNum?design_id=" + ref_id, function (data) {

      if (data.name_number) {
        nnobj.show();
        console.log(data.name_number);
      }

    });

  });

  $(".nnlink").click(function () {
    var nnobj = $(this);
    var ref_id = nnobj.attr('data-refid');
    var varId = nnobj.attr('data-varId');
    $.get(APP_URL + "api/v1/carts/nameNumber?design_id=" + ref_id + "&variant_id=" + varId, function (data) {
      if (data != undefined) {
        var tableContent = ' <span class="close">&times;</span><table><tr>';
        $.each(data.fields, function (hKey, heading) {
          tableContent += "<th>" + heading + "</th>";
        });
        tableContent += "</tr>";
        $.each(data.values, function (rKey, row) {
          tableContent += "<tr>";
          $.each(row, function (cKey, content) {
            if (content.toString().indexOf("http") > -1) {
              tableContent += '<td><img src="' + content + '" width="50" height="50"></td>';
            } else {
              tableContent += "<td>" + content + "</td>";
            }
          });
          tableContent += "</tr>";
        });
        tableContent += "</table>";
        $('.nnmodal-content').html(tableContent);
        $("#nnModal").show();
      }
    });
  });
  //var modal = document.getElementById("nnModal");
  //$(document).on('click','.close',function(){
  //  $("#nnModal").hide();
  // });

  //var span = document.getElementsByClassName("close")[0];
  //span.onclick = function() {
  //  modal.style.display = "none";
  //}

  // When the user clicks anywhere outside of the modal, close it
  //window.onclick = function(event) {
  //  if (event.target == modal) {
  //    modal.style.display = "none";
  //  }
  //}

  // Name number data
  //   image replace for customized items here
  $(".ref-preview-img").each(function () {
    var obj = $(this);
    var ref_id = obj.attr('data-ref-id');
    var varId = obj.attr('data-varId');
    var size = '';
    var spid = '';
    var encParam = ref_id + "@" + varId + "@";
    var token = encrypt(encParam, secretKeyData);
    $.get(APP_URL + "api/v1/preview-images?token=" + token, function (data) {
      if (ref_id != undefined) {
        $.each(data, function (key, val) {
          if (key == ref_id && val.length > 0) {
            $.each(val, function (imgKey, imgObj) {
              var newElement = '<li  class="product-image product-thumb customize-image" title="">' + '<img src="' + imgObj['customImageUrl'][imgKey] + '" width="75" height="75" alt="" rel="' + ref_id + '" style="display:block;" class="previewimg">' + '</li>';
              //arr.push(newElement);
              $(obj).append(newElement);
              $(obj).find('span').remove();
              // hide name and number info link
              if (imgObj['nameAndNumber'] == 0) {
                jQuery(".nninfo_" + key).hide();
              }
              //show custom size in variable boundary.
              //            if (imgObj['variableDecorationSize']) {
              //                $(obj).append('<li>custom ' + imgObj['sizeAttr'] + ': ' + imgObj['variableDecorationSize'] + ' ' + imgObj['variableDecorationUnit'] + '</li>');
              // }
            });
          }
        });
      }
    });
  });
  /**
   * Get encrypted order data string.
   *
   * @param {string} urlToEncode - order data string
   * @param {string} secretKey - secret key
   */
  function encrypt(urlToEncode, secretKey) {
    let enCodedBit, encryptedTxt = '', cipherKey = '5';
    urlToEncode += secretKey;

    for (let i = 0; i < urlToEncode.length; i++) {
      enCodedBit = String.fromCharCode(urlToEncode[i].charCodeAt(0) + cipherKey.charCodeAt(0));
      encryptedTxt += enCodedBit;
    }
    encryptedTxt = (btoa(encryptedTxt))
    return encryptedTxt;
  }
  // cart edit content here

  $.getJSON('/cart.js', function (cartData) {
    if (cartData) {
      var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      $.each(cartData.items, function (key, item) {
        var editURL = '';
        var pid = '';
        var dpid = '';
        var thisPid = '';
        var thisVid = '';
        var vid = '';
        var qty = '';
        var sku = '';
        var cart_item_id = '';
        var ids = '';
        
      var custID = 0;
      
      thisPid = item.product_id;
      thisVid = item.variant_id;
      dpid = item.properties._refid;
      qty = item.quantity;
      cart_item_id = (key + 1);
      $.get(APP_URL + 'api/v1/secretkey', function (html) {
        var secretKeyData = JSON.parse(html);
      })
      $.get(APP_URL + "api/v1/shopify-product/" + thisVid, function (orgid) {
        var ids = JSON.parse(orgid);
        pid = ids.pid;
        vid = ids.vid;
        var urlparam = 'customer=' + custID + '&id=' + pid + '&vid=' + vid + '&dpid=' + dpid + '&qty=' + qty + '&cart_item_id=' + cart_item_id;
        var encryptUrl = encrypt(urlparam, secretKeyData);
        $.get(APP_URL + "api/v1/carts/set-delivery-option?old_varID=" + vid + "&new_varID=" + thisVid, function (data) {
          console.log(data);
        });
        if (isMobile || navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
          editURL = APP_URL + 'mobile/index.html?' + encryptUrl;
        } else {
          editURL = '/pages/designer-studio?' + encryptUrl;
        }
        var itemKey = item.key;
        var selector = itemKey.replace(":", "\\:")
        $('#' + selector).attr("href", editURL);

      });

    });
}
});

});

//page reload on updating product quantity
$('.cart-item-quantity .quantity__button').click(function () {
  setTimeout(function () {
    location.reload();
  }, 2000);
});

//page reload on changing product quantity manually
if (window.location.href.indexOf("/cart") > -1) {
  $("input").change(function () {
    setTimeout(function () {
      location.reload();
    }, 2000);
  });

}

//page reload on deleting a product
$("cart-remove-button").click(function () {
  setTimeout(function () {
    location.reload();
  }, 2000);
});

//to check if Direct Add to Cart flow is enabled 
document.addEventListener('DOMContentLoaded', () => {
  const impCartFlowEle = document.querySelector('#impCartFlow');
  impCartFlow = impCartFlowEle.innerText;
  const customVarEle = document.querySelector('#customVarId');
  customVarId = customVarEle.innerText;
});

function addItem() {
  var query_string = {};
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    // If first entry with this name
    if (typeof query_string[pair[0]] === "undefined") {
      query_string[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
    } else if (typeof query_string[pair[0]] === "string") {
      var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
      query_string[pair[0]] = arr;
      // If third or later entry with this name
    } else {
      query_string[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }

  //delete the line item if in edit setting its set like that
  if (query_string.edit && query_string.edit != "") {

    let deleteItem = {
      'line': parseInt(query_string.edit),
      'quantity': 0
    };
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(deleteItem)
    })
      .then(response => {
        console.log("item deleted else does not matter")
      })
      .catch((error) => {
        alert('Something went wrong please try again!');
      });

  }

  /* Ref URL Parts
      0: Imprint design ref ID
      1: shopify variant id
      2: quantity ordered   
      3: parent_variant ID
  */
  //get potential of multiple items
  var items = query_string.ref.split('--');
  var itemNum = (items.length) - 1;
  //console.log(itemNum);
  var waiting = 5000;
  if (itemNum > 0) {
    waiting = itemNum * 2000;
  }

  //loop through items and prepare post data
  let allItems = [];
  let variationsID = [];

  for (var i in items) {
    //var this_item =items[i].split('-'); 
    var this_item = items[i].split(/-|\|\|/);
    let properties = {
      '_refid': this_item[0],
      '_parent_var_id': this_item[3] + '||' + this_item[4] // Common concatenation
    };
  //condition to show and hide upload button for customized product
    if(this_item[0] > 0) {
          properties['preview'] = APP_URL + 'custom_template.html?ref_id='+ this_item[0] + '&tp=/uploads/';
    }

    // Add 'Custom price' only if this_item[4] is valid and impCartFlow is true
    if (this_item[4] != 0 && impCartFlow == 'true') {
      properties['Custom price'] = parseFloat(this_item[4]).toFixed(2);
    }

    // Additional conditions for dynamic keys
    if (this_item[0] != 0 && this_item[4] != 0) {
      if (impCartFlow == 'true') {
        if (this_item[5] != 'default') {
          properties[this_item[5]] = this_item[6];
        }
      }
    }


    let oneItem = {
      'id': parseInt(this_item[1]),
      'quantity': parseInt(this_item[2]),
      'properties': properties
    };

    if (variationsID.includes(parseInt(this_item[1])) === false && impCartFlow != 'true') {
      allItems.push(oneItem);
      variationsID.push(parseInt(this_item[1]));
    } else {
      allItems.push(oneItem);
    }


  }
  // if valid data is there call shopify add to cart api
  if (Array.isArray(allItems) && allItems.length === 0) {
    alert('Invalid or unavailable products could not be added to the cart.')
  } else {
    let formData = {
      'items': allItems
    };
    if (query_string.edit && query_string.edit != "") {
      setTimeout(function () {
        callShopCart4IMP(formData);
      }, 2000);
    } else {
      var waitTime = 2000;
      if (formData.length > 2) {
        waitTime = 5000;
      }
      setTimeout(function () {
        callShopCart4IMP(formData);
      }, waitTime);
    }
  }
}


function callShopCart4IMP(formData) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (response.ok) {
        setTimeout(function () { window.location.href = '/cart'; }, 2000);
      } else {
        setTimeout(function () {
          location.reload();
        }, 1000);
      }
    })
    .catch((error) => {
      alert('Something went wrong please try again!');
    });
}

function reorderfromImprint(orderID, elem) {
  $(elem).text("Processing...");
  $(elem).prop("onclick", null);
  var cartForm = new FormData();
  cartForm.append("orderID", orderID);

  var postSettings = {
    "url": APP_URL + "api/v1/reorder",
    "method": "POST",
    "timeout": 0,
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
    "data": cartForm
  };

  $.ajax(postSettings).done(function (response) {
    const cartObj = JSON.parse(response);
    if (cartObj.status && cartObj.cart_link != "") {
      window.location.href = cartObj.cart_link;
    } else {
      alert("The items of this order are either out of stock or the order designs are not saved");
      $(elem).text("Reorder");
    }
    console.log(cartObj.status);
  });
  //alert(orderID);
}

// Function to update cart item display prices as per custom price
async function fetchAndProcessCartData() {
  const response = await fetch(window.Shopify.routes.root + 'cart.js');
  const data = await response.json();

  if (impCartFlow === 'true') {
    // Code to be executed if impCartFlow is "true"
    // Process cart data
    cartItems = data.items;
    var totalPrice = 0;
    var currencySymbol = '';
cartItems.forEach((item, index) => {
      let customPrice = 0;
      let quantity = item.quantity;
      if (item.properties && item.properties['Custom price']) {
        customPrice = parseFloat(item.properties['Custom price']) * quantity;
      }
      let originalPrice = item.final_line_price / 100; // Shopify returns price in cents
      let newPrice = originalPrice + customPrice;
      totalPrice = totalPrice + newPrice;
      if (customPrice > 0) {
        let cartItemRow = document.querySelector(`#CartItem-${index + 1}`);
       let priceElement = cartItemRow.querySelector('td:not(.large-up-hide) .cart-item__price-wrapper .price.price--end:not(.cart-item__old-price)');
        if (priceElement) {
          let price = priceElement.innerText || priceElement.textContent;
          currencySymbol = price.match(/[^\d.,]+/g)?.join('');
          priceElement.innerText = currencySymbol + newPrice.toFixed(2);

      }
    }
    document.querySelector('.totals__subtotal-value, .totals__total-value').innerText = currencySymbol + totalPrice.toFixed(2);
    })

  } else {
    console.log("impCartFlow is not enabled");
  }
}



function updateCartWidImpProds(cartItems) {
  document.getElementById("Imp-checkout").innerHTML = "Processing ...";
  let lineItemArr = [];

  cartItems.forEach(eachCart => {
    let customPrice = eachCart.properties?.['Custom price'] ?? 0; 
    let refId = eachCart.properties ?.['_refid'] ?? 0;
    let title;
    if (eachCart.properties && customPrice > 0) {
      let qty = customPrice * 100 * eachCart.quantity;
      if (eachCart.title) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(eachCart.title, "text/html");
        title = doc.documentElement.textContent;
      }
     
      let customLineitem = {
        id: Number(customVarId),
        quantity: qty,
        properties: {
          'custom price for linked product': title,
          '_refId' : refId
        }
      };
      lineItemArr.push(customLineitem);
    }

    if (eachCart.properties && refId > 0) {
      eachCart.properties.preview = APP_URL + 'custom_template.html?ref_id='+ refId + '&tp=/uploads/';
    }

  });


  let customProds = {
    items: lineItemArr
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(customProds)
  })
    .then(response => {
      setTimeout(function () {
        document.querySelector('.cart__checkout-button').click();
      }, 1000);

    })
    .catch((error) => {
      alert("The checkout of the items did not happen. Please check the stocks of the items and try again!!! ");
    });

}
